export const state = {
	currentRoutePath: '',
	isAppView: false,
	isMapVisible: false,
	isSearchToggled: false,
	detailView: {}
};

type DetailViewState = {
	detailView?: {
		selectedMarker?: string | number | null;
		mode?: DetailViewMode;
	};
};

export type DetailViewMode = 'preview' | 'full' | null;

export type State = typeof state & DetailViewState;
